import { Box, Divider, Grid, Modal } from '@mui/material'
import React from 'react'
import WarningRoundedIcon from '@mui/icons-material/WarningRounded'
import { TextBold, TextRegular } from '../../../commonComponents/TextStyling'
import { useTheme } from '@mui/styles'
import AppButton from '../../../commonComponents/AppButton'

const style = {
  position: 'absolute',
  top: '20%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 5,
  p: 0
}

const responsiveStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 5,
  p: 0,
  width: '85%'
}

export default function CautionModal ({ data, matches }) {
  var { open, onClose, changeStep } = data
  const theme = useTheme()
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={matches ? responsiveStyle : style}>
        <Grid container spacing={0}>
          <Grid
            item
            xs={12}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '14px',
              background: theme.palette.background.shade,
              borderTopRightRadius: '8px',
              borderTopLeftRadius: '8px'
            }}
          >
            <WarningRoundedIcon style={{ marginRight: '6px' }} />
            <TextBold>Caution</TextBold>
          </Grid>
          <Grid item xs={12}>
            <Divider style={{ width: '100%' }} />
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '14px'
            }}
          >
            <TextRegular>
              It’s very important for us to know the basic information about
              your recruiting background. It will help us develop a better
              relationship and trust with you when sharing sensitive information
              about our clients.
            </TextRegular>
          </Grid>
        </Grid>
        <Divider style={{ width: '100%' }} />

        <Grid
          container
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'right',
            padding: '14px'
          }}
        >
          <Grid item xs={matches ? 12 : 6}>
            <Grid container justifyContent={'space-between'}>
              <Grid item xs={5}>
                <AppButton name={'Yes, I got it'} onClick={onClose} />
              </Grid>
              <Grid item xs={6}>
                <AppButton
                  variant='text'
                  name={'Skip this step for now'}
                  onClick={() => {
                    changeStep()
                    onClose()
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  )
}
